import { Modal } from 'bootstrap'
import dayjs from 'dayjs'
import { datepicker, datetimepicker } from 'flatpickr-prefabs'
import {
    ddlClientContactInitialise,
    ddlClientInitialise,
    ddlGenericInitialise,
    ddlLogTypeInitialise
} from 'slim-select-prefabs'
import { DataTable } from 'simple-datatables'
import { validateStyle } from 'validate-style-animations'
import { fadeIn, fadeOut } from 'fade-animations'
import { InitialiseSearchLogTable } from './layoutDataTables'
import { easyMDEInit } from './easyMDE'
import { popoverInitialise, modalMove, formSubmits, clientSelectButtons, timeCheck } from './utils'
import { sanitise } from 'sanitise-fields'

export const ddlClientArray = ddlClientInitialise()
export const ddlClientContactArray = ddlClientContactInitialise()
export const ddlLogType = ddlLogTypeInitialise()
export const ddlGeneric = ddlGenericInitialise()

window.addEventListener('load', () => {
    initialise()
})

const initialise = () => {
    customPageLoad()
    onLoad()
    const { forms } = document
    if (forms != null) {
        Array.from(forms).forEach((form: HTMLFormElement) => {
            form.setAttribute('autocomplete', 'off')
        })
    }
    const keepPanelAlive = document.querySelector('.keep-alive-panel') as HTMLFormElement
    if (keepPanelAlive != null) {
        keepPanelAlive.style.opacity = '0'
    }
    let { href } = window.location
    if (href.toLowerCase().indexOf('login') === -1) {
        const hidkeepalive = document.getElementById('hidkeepalive') as HTMLFormElement
        setInterval(() => {
            fetch(
                hidkeepalive.value.toString(),
                {
                    method: 'GET'
                }
            )
                .then((response) => response.json())
                .then((result) => {
                    fadeIn(keepPanelAlive)
                    setInterval(() => {
                        fadeOut(keepPanelAlive)
                    }, 2000)
                })
        }, 20000)
    }
    if ((navigator.userAgent.indexOf('MSIE') !== -1) && (window.location.href.indexOf('Login') > 0)) { // IF IE > 10
        alert('Internet Explorer is not officially supported by the MiniPalSuite. You may encounter technical issues should you continue to use it. We encourage the use of a modern browser.')
    }

    const btnDownloadMPS = document.querySelector('.btnDownloadMPS') as HTMLFormElement
    if (btnDownloadMPS != null) {
        const location = window.location.href.toLowerCase()
        btnDownloadMPS.setAttribute('href', `${location.toString()}/files/mps.exe`)
        btnDownloadMPS.setAttribute('target', '_blank')
    }
    const btnAddLog = document.querySelector('.btnAddLog') as HTMLFormElement
    btnAddLog.addEventListener('click', () => {
        const AddLogPartialContent = document.querySelector('.AddLogPartialContent') as HTMLFormElement
        AddLogPartialContent.innerHTML = ''
        const hidAddLog = document.getElementById('hidAddLog') as HTMLFormElement
        fetch(hidAddLog.value.toString(), {
            method: 'POST'
        })
            .then((response) => response.text())
            .then((result) => {
                AddLogPartialContent.innerHTML = result
                formSubmits()
                ddlClientInitialise()
                ddlClientContactInitialise()
                ddlLogTypeInitialise()
                ddlGenericInitialise()
                const AddLogLogo = document.querySelector('.AddLogLogo') as HTMLImageElement
                const MyLast10Table = document.querySelector('.MyLast10Table') as HTMLImageElement
                const MyLast10Label = document.querySelector('.MyLast10Label') as HTMLImageElement
                const Last10Table = document.querySelector('.Last10Table') as HTMLImageElement
                const Last10Label = document.querySelector('.Last10Label') as HTMLImageElement
                const pTimeSinceLastLog = document.getElementById('pTimeSinceLastLog') as HTMLImageElement
                const pTimeSinceLastLogLasted = document.getElementById(
                    'pTimeSinceLastLogLasted'
                ) as HTMLImageElement

                if (AddLogLogo != null) {
                    AddLogLogo.classList.remove('d-block', 'mx-auto')
                    AddLogLogo.classList.add('d-none')
                }
                if (MyLast10Table != null) {
                    MyLast10Table.classList.add('d-none')
                }
                if (MyLast10Label != null) {
                    MyLast10Label.classList.add('d-none')
                }
                if (Last10Table != null) {
                    Last10Table.classList.add('d-none')
                }
                if (Last10Label != null) {
                    Last10Label.classList.add('d-none')
                }
                if (pTimeSinceLastLog != null) {
                    pTimeSinceLastLog.innerHTML = ''
                }
                if (pTimeSinceLastLogLasted != null) {
                    pTimeSinceLastLogLasted.innerHTML = ''
                }
                onLoad()
                const dataTablesWrapper = document.querySelector('.dataTables_wrapper no-footer')
                if (dataTablesWrapper != null) {
                    dataTablesWrapper.classList.add('d-none')
                }
                const LogComment = document.querySelector('.LogComment') as HTMLFormElement
                if (LogComment != null) {
                    LogComment.addEventListener('keyup', () => {
                        sanitise()
                    })
                }
                const sharebutton = document.querySelector('.sharebutton') as HTMLFormElement
                sharebutton.addEventListener('click', () => {
                    const LogContactTypeID = document.getElementById('ddlLogContactType') as HTMLSelectElement
                    if (navigator.share) {
                        navigator
                            .share({
                                title: LogContactTypeID.value.toString(),
                                text: LogComment.value.toString(),
                                url: window.location.origin
                            })
                            .then(() => console.log('Successful share'))
                            .catch((error) => console.log('Error sharing', error))
                    } else {
                        const shareModalDiv = document.querySelector('.shareModal') as HTMLFormElement
                        const shareModal = new Modal(shareModalDiv, {
                            backdrop: true,
                            keyboard: true
                        })
                        shareModal.show()
                    }
                })
                let urlRequest = '/Requests/TimeSinceLastLog'
                fetch(urlRequest, {
                    method: 'POST'
                })
                    .then((response) => response.text())
                    .then((result) => {
                        const LogDate = document.querySelector('.LogDate') as HTMLInputElement
                        LogDate.value = dayjs().format('DD/MM/YYYY HH:mm')
                        const LogComment = document.getElementById('LogComment') as HTMLInputElement
                        LogComment.value = ''
                        const LogHours = document.getElementById('LogHours') as HTMLInputElement
                        LogHours.value = '0'
                        const LogMinutes = document.getElementById('LogMinutes') as HTMLInputElement
                        LogMinutes.value = '0'
                        const pTimeSinceLastLog = document.getElementById(
                            'pTimeSinceLastLog'
                        ) as HTMLInputElement
                        if (pTimeSinceLastLog != null) {
                            pTimeSinceLastLog.innerHTML = `Last log was at: ${result} ago`
                        }
                        const AddLogDiv = document.getElementById('AddLog') as HTMLFormElement
                        const AddLog = new Modal(AddLogDiv, {
                            backdrop: true,
                            keyboard: true
                        })
                        AddLog.show()
                    })
                    .catch((ex) => {
                        alert(`Failed calling /Requests/TimeSinceLastLog: ${ex}`)
                    })
                urlRequest = '/Requests/TimeSinceLastLogAdjusted'
                const btnLast10Logs = document.querySelector('.btnLast10Logs') as HTMLFormElement
                if (btnLast10Logs != null) {
                    btnLast10Logs.addEventListener('click', () => {
                        const ddlClientID = document.querySelector('.ddlAddLogClientID') as HTMLSelectElement
                        const ddlClientIDSlim = ddlClientID.nextElementSibling
                            .firstElementChild as HTMLFormElement
                        if (ddlClientID.value.toString() !== '0') {
                            const hidGetClientLast10Logs = document.getElementById(
                                'hidGetClientLast10Logs'
                            ) as HTMLFormElement
                            fetch(
                                `${hidGetClientLast10Logs.value.toString()}?id=${encodeURIComponent(
                                    parseInt(ddlClientID.value.toString())
                                )}`,
                                {
                                    method: 'POST'
                                }
                            )
                                .then((response) => response.json())
                                .then((result) => {
                                    const tableId = document.querySelector('.Last10Table')
                                    let tBody = tableId.getElementsByTagName('tbody')[0]
                                    if (tBody !== undefined) {
                                        tableId.removeChild(tBody)
                                    }
                                    tableId.appendChild(document.createElement('tbody'))
                                    tBody = tableId.getElementsByTagName('tbody')[0] as HTMLTableSectionElement
                                    result.forEach((elem: any) => {
                                        // states contains the JSON formatted list
                                        // of states passed from the controller
                                        const MyDateStringValue = elem.ContactsLogDate
                                        const value = new Date(MyDateStringValue)
                                        const month = value.getMonth()
                                        const monthactual = month + 1
                                        const dat = `${value.getDate()}/${monthactual}/${value.getFullYear()} ${value.getHours()}:${value.getMinutes()}`
                                        if (elem.name === ' ') {
                                            elem.name = 'No contact assigned'
                                        }
                                        if (elem.ContactDetails === null) {
                                            elem.ContactDetails = 'No contact details available'
                                        }
                                        if (elem.Note === null) {
                                            elem.Note = 'No note found'
                                        }
                                        if (elem.NoteShort === null) {
                                            elem.NoteShort = 'No note found'
                                        }
                                        tBody.insertAdjacentHTML(
                                            'beforeend',
                                            `<tr><td><div><span id="popOverNote" rel="popover"><a tabindex="0" class="popoverNote popoverCaption" data-bs-trigger="focus" data-bs-toggle="popover" data-html="true" data-content="${elem.PalomaEmployeeDetails}">${elem.PalomaEmployee}</a></span></div></td><td><div><span id="popOverNote" rel="popover"><a tabindex="0" class="popoverNote popoverCaption" data-bs-trigger="focus" data-bs-toggle="popover" data-html="true" data-content="${elem.ContactDetails}">${elem.name}</a></span></div></td><td>${dat}</td><td><div><span id="popOverNote" rel="popover"><a tabindex="0" class="popoverNote popoverCaption" data-bs-trigger="focus" data-bs-toggle="popover" data-html="true" data-content="${elem.Note}">${elem.NoteShort}</a ></span></div></td></tr> `
                                        )
                                    })
                                    popoverInitialise()
                                })
                                .catch((ex) => {
                                    alert(`Failed to retrieve logs.${ex}`)
                                })
                            if (AddLogLogo != null) {
                                fadeOut(AddLogLogo)
                            }
                            if (MyLast10Table != null) {
                                fadeOut(MyLast10Table)
                            }
                            if (MyLast10Label != null) {
                                fadeOut(MyLast10Label)
                            }
                            if (Last10Table != null) {
                                fadeIn(Last10Table)
                            }
                            if (Last10Label != null) {
                                fadeIn(Last10Label)
                            }
                            validateStyle(ddlClientIDSlim, false)
                        } else {
                            validateStyle(ddlClientIDSlim, true)
                        }
                    })
                }
                const btnMyLast10Logs = document.querySelector('.btnMyLast10Logs') as HTMLFormElement
                if (btnMyLast10Logs != null) {
                    btnMyLast10Logs.addEventListener('click', () => {
                        const ddlClientID = document.querySelector('.ddlAddLogClientID') as HTMLSelectElement
                        const ddlClientIDSlim = ddlClientID.nextElementSibling
                            .firstElementChild as HTMLFormElement
                        if (ddlClientID.value.toString() !== '0') {
                            const hidGetClientMyLast10Logs = document.getElementById(
                                'hidGetClientMyLast10Logs'
                            ) as HTMLFormElement
                            fetch(
                                `${hidGetClientMyLast10Logs.value.toString()}?id=${encodeURIComponent(
                                    parseInt(ddlClientID.value.toString())
                                )}`,
                                {
                                    method: 'POST'
                                }
                            )
                                .then((response) => response.json())
                                .then((result) => {
                                    const tableId = document.querySelector('.MyLast10Table')
                                    let tBody = tableId.getElementsByTagName('tbody')[0]
                                    if (tBody !== undefined) {
                                        tableId.removeChild(tBody)
                                    }
                                    tableId.appendChild(document.createElement('tbody'))
                                    tBody = tableId.getElementsByTagName('tbody')[0] as HTMLTableSectionElement
                                    result.forEach((elem: any) => {
                                        // states contains the JSON formatted list
                                        // of states passed from the controller
                                        const MyDateStringValue = elem.ContactsLogDate
                                        const value = new Date(MyDateStringValue)
                                        const month = value.getMonth()
                                        const monthactual = month + 1
                                        const dat = `${value.getDate()}/${monthactual}/${value.getFullYear()} ${value.getHours()}:${value.getMinutes()}`
                                        if (elem.name === ' ') {
                                            elem.name = 'No contact assigned'
                                        }
                                        if (elem.ContactDetails === null) {
                                            elem.ContactDetails = 'No contact details available'
                                        }
                                        if (elem.Note === null) {
                                            elem.Note = 'No note found'
                                        }
                                        if (elem.NoteShort === null) {
                                            elem.NoteShort = 'No note found'
                                        }
                                        tBody.insertAdjacentHTML(
                                            'beforeend',
                                            `<tr><td>${elem.PalomaEmployee}</td><td><div><span id="popOverNote" rel="popover"><a tabindex="0" class="popoverNote popoverCaption" data-bs-trigger="focus" data-bs-toggle="popover" data-html="true" data-content="${elem.ContactDetails}">${elem.name}</a></span></div></td><td>${dat}</td><td><div><span id="popOverNote" rel="popover"><a tabindex="0" class="popoverNote popoverCaption" data-bs-trigger="focus" data-bs-toggle="popover" data-html="true" data-content="${elem.Note}">${elem.NoteShort}</a ></span></div></td></tr> `
                                        )
                                    })
                                    popoverInitialise()
                                })
                                .catch((ex) => {
                                    alert(`Failed to retrieve logs.${ex}`)
                                })
                            if (AddLogLogo != null) {
                                fadeOut(AddLogLogo)
                            }
                            if (MyLast10Table != null) {
                                fadeIn(MyLast10Table)
                            }
                            if (MyLast10Label != null) {
                                fadeIn(MyLast10Label)
                            }
                            if (Last10Table != null) {
                                fadeOut(Last10Table)
                            }
                            if (Last10Label != null) {
                                fadeOut(Last10Label)
                            }
                            validateStyle(ddlClientIDSlim, false)
                        } else {
                            validateStyle(ddlClientIDSlim, true)
                        }
                    })
                }
                const btnClientSearch = document.querySelector('.btnClientSearch')
                if (btnClientSearch != null) {
                    btnClientSearch.addEventListener('click', () => {
                        ClientSearchModal()
                    })
                }
                const btnAddContact = document.querySelector('.btnAddContact') as HTMLFormElement
                btnAddContact.addEventListener('click', () => {
                    const hidAddClientContact = document.getElementById(
                        'hidAddClientContact'
                    ) as HTMLFormElement
                    const AddContactPartialContent = document.querySelector(
                        '.AddContactPartialContent'
                    ) as HTMLFormElement
                    fetch(hidAddClientContact.value.toString(), {
                        method: 'POST'
                    })
                        .then((response) => response.text())
                        .then((result) => {
                            AddContactPartialContent.innerHTML = result
                            formSubmits()
                            const ddlClientID = document.querySelector('.ddlClientID') as HTMLSelectElement
                            const ddlAddContactClientID = document.getElementById(
                                'ddlAddContactClientID'
                            ) as HTMLSelectElement
                            if (ddlClientID.value.toString() !== '0') {
                                ddlAddContactClientID.value = ddlClientID.value
                            }
                            ddlClientInitialise()
                            const AddContactDiv = document.querySelector('.AddContact') as HTMLFormElement
                            const AddContact = new Modal(AddContactDiv, {
                                backdrop: true,
                                keyboard: true
                            })
                            AddContact.show()
                        })
                })
                timeCheck()
                const btnAddLogRecord = document.querySelector('.btnAddLogRecord') as HTMLButtonElement
                if (btnAddLogRecord != null) {
                    btnAddLogRecord.addEventListener('click', () => {
                        const hidAddClientLog = document.getElementById('hidAddClientLog') as HTMLFormElement
                        const form = document.querySelector('.formAddLog') as HTMLFormElement
                        const client = document.getElementById('ddlLogClientID') as HTMLSelectElement
                        const ddlClientIDSlim = client.nextElementSibling!.firstElementChild
                        const hours = document.querySelector('.LogHours') as HTMLInputElement
                        const minutes = document.querySelector('.LogMinutes') as HTMLInputElement
                        if (hours.value.toString() === '' || hours === null) {
                            hours.value = '0'
                        }
                        if (minutes.value.toString() === '' || minutes === null) {
                            minutes.value = '0'
                        }

                        if (client.value.toString() === '0' || client == null) {
                            validateStyle(ddlClientIDSlim)
                        }

                        if (hours.value.toString() === '0' && minutes.value.toString() === '0') {
                            validateStyle(minutes)
                            validateStyle(hours)
                        }
                        if (
                            client.value.toString() !== '0' &&
                            (hours.value.toString() !== '0' || minutes.value.toString() !== '0')
                        ) {
                            validateStyle(ddlClientIDSlim, false)
                            validateStyle(minutes, false)
                            validateStyle(hours, false)
                            // Validated
                            fetch(hidAddClientLog.value.toString(), {
                                method: 'POST',
                                body: new FormData(form)
                            }).then(() => {
                                const emailLog = document.querySelector('.EmailLog') as HTMLInputElement
                                if (emailLog.checked === true) {
                                    const comment = document.querySelector('.LogComment') as HTMLInputElement
                                    const commentNoLineBreaks = comment.value.replace(/\n/g, '%0D%0A')
                                    const commentLogNoAmpersand = commentNoLineBreaks.replace(/&/g, 'and')
                                    let commentLog = commentLogNoAmpersand.replace(/% /g, ' percent ')
                                    href = href.replace('#', '')
                                    commentLog += `%0D%0A%0D%0A${href}/Client/ViewClient/${$('.ddlClientID').val()}`
                                    const emailSubject = `${$('.ddlClientID').find(':selected').text()} | Email Log`
                                    const emailSubjectNoAmpersand = emailSubject.replace(/&/g, 'and')
                                    const clientContact = $('.ClientContact option:selected').text().split('(')[0]
                                    window.location.href = `mailto:?subject=${emailSubjectNoAmpersand}&body=Logged to client contact: ${clientContact}%0D%0A%0D%0ALog%0D%0A%0D%0A${commentLog}`
                                    $('.AddLog').modal('hide')
                                    setTimeout(() => {
                                        window.location.reload()
                                    }, 250)
                                } else {
                                    window.location.reload()
                                }
                            })
                        } else {
                            return false
                        }
                    })
                }
            })
    })
    const btnNewClient = document.querySelector('.btnNewClient') as HTMLFormElement
    btnNewClient.addEventListener('click', () => {
        const hidAddOrganisation = document.getElementById('hidAddOrganisation') as HTMLFormElement
        const AddOrganisationPartialContent = document.querySelector('.AddOrganisationPartialContent') as HTMLFormElement
        fetch(
            hidAddOrganisation.value.toString(),
            {
                method: 'POST'
            }
        )
            .then((response) => response.text())
            .then((result) => {
                AddOrganisationPartialContent.innerHTML = result
                formSubmits()
                ddlGenericInitialise()
            })
        const AddClientDiv = document.querySelector('.AddClient') as HTMLFormElement
        const AddClient = new Modal(AddClientDiv, {
            backdrop: true,
            keyboard: true
        })
        AddClient.show()
    })
    const btnAddConcern = document.querySelector('.btnAddConcern') as HTMLFormElement
    btnAddConcern.addEventListener('click', () => {
        const ddlClientID = document.querySelector('.ddlClientID') as HTMLSelectElement
        const ConcernLogComment = document.querySelector('.ConcernLogComment') as HTMLFormElement
        if (ddlClientID.value.toString() !== '0' && ConcernLogComment.value.toString() !== '') {
            const urlRequest = '/Home/AddClientIssue'

            const ConcernLogComment = document.querySelector('.ConcernLogComment') as HTMLTextAreaElement
            const ddlClientID = document.querySelector('.ddlClientID') as HTMLSelectElement
            fetch(
                `${urlRequest
                }?IssueComment=${encodeURIComponent(ConcernLogComment.value.toString())
                }&ClientID=${encodeURIComponent(ddlClientID.value.toString())}`,
                {
                    method: 'POST'
                }
            )
                .then((response) => response.json())
                .then((result) => {
                    const shareModalDiv = document.querySelector('.shareModal') as HTMLFormElement
                    const shareModal = new Modal(shareModalDiv, {
                        backdrop: true,
                        keyboard: true
                    })
                    const createConcernDiv = document.querySelector('.createConcern') as HTMLFormElement
                    const createConcern = new Modal(createConcernDiv, {
                        backdrop: true,
                        keyboard: true
                    })
                    shareModal.hide()
                    createConcern.hide()
                })
                .catch((ex) => {
                    alert(`Failed calling /Home/AddClientIssue: ${ex}`)
                })
        } else {
            const ConcernLogComment = document.querySelector('.ConcernLogComment') as HTMLTextAreaElement
            if (ConcernLogComment.value.toString() != '' && ConcernLogComment != null) {
                ConcernLogComment.classList.add('border-color', 'red')
            } else {
                ConcernLogComment.classList.add('border-color', '#ced4da')
            }
            const ddlClientID = document.querySelector('.ddlClientID') as HTMLTextAreaElement
            const ClientMissingText = document.querySelector('.ClientMissingText')
            if (ddlClientID.value.toString() != '0' && ddlClientID != null) {
                ClientMissingText.classList.add('d-block')
            } else {
                ClientMissingText.classList.add('d-none')
            }
        }
    })
    const mdeEditors = document.querySelectorAll('.mdeEditor')
    mdeEditors.forEach((mdeEditor: HTMLTextAreaElement) => {
        if (mdeEditor.style.display !== 'none') {
            easyMDEInit(mdeEditor)
        }
    })
}
const stopCountDown = (intervalObject: any) => {
    if (intervalObject != null) {
        clearInterval(intervalObject)
        intervalObject = null
    }
}
const ShowDialog = () => {
    const AutoCloseModalDiv = document.querySelector('.AutoCloseModal') as HTMLFormElement
    const AutoCloseModal = new Modal(AutoCloseModalDiv, {
        backdrop: true,
        keyboard: true
    })
    AutoCloseModal.show()
}
const definitelyClose = () => {
    const hidSignOut = document.getElementById('hidSignOut') as HTMLFormElement
    window.location.href = hidSignOut.value as string
}
const promptForClose = (intervalObject: any, warnPeriod: any) => {
    stopCountDown(intervalObject)
    ShowDialog()
    autoCloseTimer = setTimeout(() => { definitelyClose() }, warnPeriod)
}
const displayTime = (seconds: number, intervalObject: any, warnPeriod: number) => {
    const s = document.getElementById('spanTimeRemaining')
    if (s != null) {
        gSeconds = seconds - 1
        s.innerHTML = ` - &nbsp;log out in&nbsp;${gSeconds}s`
        if (seconds === 1) {
            promptForClose(intervalObject, warnPeriod)
        }
    }
}
const startCountDown = (intervalObject: any, warnPeriod: number) => {
    if (intervalObject != null) {
        clearInterval(intervalObject)
    }
    intervalObject = setInterval(() => { displayTime(gSeconds, intervalObject, warnPeriod) }, 1000)
}
let gSeconds: number = 10
let autoCloseTimer: any = null
const customPageLoad = () => {
    const intervalObject: any = null
    const warnPeriod: number = 15000
    const AutoCloseSeconds = document.getElementById('hidAutoCloseSeconds') as HTMLFormElement
    gSeconds = AutoCloseSeconds.value
    const AutoCloseModal = document.querySelector('.AutoCloseModal')
    if (AutoCloseModal != null) {
        AutoCloseModal.addEventListener('hidden.bs.modal', (e) => {
            cancelClose(intervalObject, warnPeriod)
        })
        const { body } = document
        body.addEventListener('keydown mousedown mouseover mousemove', () => {
            resetTimeout(intervalObject, warnPeriod)
        })
        try {
            if (window.location.href.toLowerCase().indexOf('login') === -1) {
                startCountDown(intervalObject, warnPeriod)
            }
        } catch (err) {

        }
    }
}
const cancelClose = (intervalObject: any, warnPeriod: number) => {
    gSeconds = 10
    startCountDown(intervalObject, warnPeriod)
    clearTimeout(autoCloseTimer) // stops auto-close timer
    const AutoCloseModalDiv = document.querySelector('.AutoCloseModal') as HTMLFormElement
    const AutoCloseModal = new Modal(AutoCloseModalDiv, {
        backdrop: true,
        keyboard: true
    })
    AutoCloseModal.hide() // hides message
}
const resetTimeout = (intervalObject: any, warnPeriod: number) => {
    try {
        if (window.location.href.toLowerCase().indexOf('login') === -1) {
            startCountDown(intervalObject, warnPeriod)
        }
    } catch (err) {

    }
}
export const StopAutocomplete = () => {
    const TextSecure = document.querySelector('.TextSecure')
    if (TextSecure != null) {
        TextSecure.addEventListener('focus', () => {
            TextSecure.removeAttribute('readonly')
        })
    }
}
export const SiteLog = () => {
    const URL: string[] = window.location.href.split('/')
    let URLSection: string = ''
    const URLReferrer = document.referrer
    const RawURL = window.location.href
    const urlRequest: string = '/Home/SiteLog'
    URLSection = URL[3]
    fetch(
        `${urlRequest
        }?url=${encodeURIComponent(URLSection)
        }&urlreferrer=${encodeURIComponent(URLReferrer)
        }&rawurl=${encodeURIComponent(RawURL)}`,
        {
            method: 'POST'
        }
    )
}
const onLoad = () => {
    datepicker()
    datetimepicker()
    modalMove()
    clientSelectButtons()
    const btnCreateConcern = document.querySelector('btnCreateConcern') as HTMLFormElement
    if (btnCreateConcern != null) {
        btnCreateConcern.addEventListener('click', () => {
            const ConcernLogComment = document.querySelector('.ConcernLogComment') as HTMLTextAreaElement
            const LogComment = document.querySelector('.LogComment') as HTMLTextAreaElement
            if (ConcernLogComment != null) {
                ConcernLogComment.value = LogComment.value
                const createConcernDiv = document.querySelector('.createConcern')
                const createConcern = new Modal(createConcernDiv, {
                    backdrop: true,
                    keyboard: true
                })
                createConcern.show()
            }
        })
    }
    const btnClientSearch = document.querySelector('.btnClientSearch')
    if (btnClientSearch != null) {
        btnClientSearch.addEventListener('click', () => {
            ClientSearchModal()
        })
    }
    const btnSearchLog = document.querySelector('.btnSearchLog') as HTMLFormElement
    btnSearchLog.addEventListener('click', () => {
        const SearchLogPartialContent = document.querySelector('.SearchLogPartialContent') as HTMLFormElement
        if (SearchLogPartialContent != null) {
            SearchLogPartialContent.innerHTMl = ''
        }
        const hidSearchLog = document.getElementById(
            'hidSearchLog'
        ) as HTMLFormElement
        fetch(
            hidSearchLog.value.toString(),
            {
                method: 'POST'
            }
        )
            .then((response) => response.text())
            .then((result) => {
                SearchLogPartialContent.innerHTML = result
                formSubmits()
                onLoad()
                const txtSearchTerm = document.getElementById('txtSearchTerm') as HTMLFormElement
                InitialiseSearchLogTable(txtSearchTerm.value.toString())

                const btnSearchTerm = document.getElementById('btnSearchTerm') as HTMLFormElement
                btnSearchTerm.addEventListener('click', () => {
                    InitialiseSearchLogTable(txtSearchTerm.value.toString())
                })
                const SearchLogDiv = document.getElementById('SearchLog') as HTMLFormElement
                const SearchLog = new Modal(SearchLogDiv, {
                    backdrop: true,
                    keyboard: true
                })
                SearchLog.show()
            })
    })
    const SearchLogTable = document.getElementById('SearchLogTable') as HTMLFormElement
    if (SearchLogTable != null) {
        SearchLogTable.addEventListener('click', (e) => {
            const target = e.target as HTMLFormElement
            ViewFullLog(target.id)
        })
    }
    const btnCloseViewFullLog = document.querySelector('.btnCloseViewFullLog') as HTMLFormElement
    btnCloseViewFullLog.addEventListener('click', () => {
        const divViewFullLog = document.querySelector('.divViewFullLog') as HTMLFormElement
        fadeOut(divViewFullLog)
        const ViewClientFullLogPartialContent = document.querySelector('.ViewClientFullLogPartialContent') as HTMLFormElement
        ViewClientFullLogPartialContent.innerHTML = ''
    })
    const btnAddClient = document.querySelector('.btnAddClient') as HTMLFormElement
    btnAddClient.addEventListener('click', () => {
        const txtNewClientName = document.querySelector('.txtNewClientName') as HTMLInputElement
        const NewClientName = txtNewClientName.value
        if (NewClientName.toString() !== '' && NewClientName !== null) {
            if (txtNewClientName != null) {
                txtNewClientName.classList.remove('alert', 'alert-danger')
            }
            const hidAddClient = document.getElementById('hidAddClient') as HTMLFormElement
            const ddlNewClientProduct = document.querySelector('.ddlNewClientProduct') as HTMLSelectElement
            let NewClientProductID = ''
            if (ddlNewClientProduct != null) {
                NewClientProductID = ddlNewClientProduct.value
            }
            fetch(
                `${hidAddClient.value.toString()
                }?NewClientName=${encodeURIComponent(NewClientName.toString())
                }&ProductID=${encodeURIComponent(NewClientProductID.toString())}`,
                {
                    method: 'POST'
                }
            )
                .then((response) => response.json())
                .then((result) => {
                    if (window.location.toString().includes('Client/ViewClient')) {
                        window.location.href = `${result.clientid}`
                    } else {
                        window.location.href = `Client/ViewClient/${result.clientid}`
                    }
                })
        } else {
            txtNewClientName.classList.add('alert', 'alert-danger')
        }
    })
    formSubmits()
}
//		columns: [
//			{
//				select: 2,
//				render: function (cell) {
//					const data = cell.innerHTML
//					if (dayjs(data).isValid()) {
//						return dayjs(data).format('DD/MM/YYYY')
//					} else {
//						return ''
//					}
//				}
//			},
//			{
//				select: 4,
//				render: function (cell) {
//					const data = cell.innerHTML
//					const id = cell.parentElement.firstElementChild
//					if (data.length > 40) {
//						return '<p ID=\'' + id.innerHTML.toString() + '\' ' +
//                  '\' class=\'whitespace-nowrap btnViewFullLog\'>' +
//                  data.substring(0, 38) + '...</p>'
//					} else {
//						return '<p>' + data + '</p>'
//					}
//				}
//			},
//			{
//				select: 6,
//				sortable: false,
//				render: function (data: string) {
//					if (data != null && data !== '') {
//						return '<a href=\'' + hidViewLog.value.toString() + '/' +
//				data + '\' class=\'btn btn-success\'>View</a>'
//					}
//				}
//			}
// ],

export const ClientSearchModal = () => {
    const hidClientSearch = document.getElementById('hidClientSearch') as HTMLFormElement
    const ClientSearchPartialContent = document.querySelector('.ClientSearchPartialContent') as HTMLFormElement
    ClientSearchPartialContent.innerHTML = ''
    fetch(
        hidClientSearch.value.toString(),
        {
            method: 'POST'
        }
    )
        .then((response) => response.text())
        .then((result) => {
            ClientSearchPartialContent.innerHTML = result
            formSubmits()
            const ClientSearchDiv = document.getElementById('ClientSearch') as HTMLFormElement
            const ClientSearch = new Modal(ClientSearchDiv, {
                backdrop: true,
                keyboard: true
            })
            ClientSearchTable()
            ClientSearch.show()
        })
}
export const ViewFullLog = (id: string) => {
    const ContactLogID = id
    const divViewFullLog = document.querySelector('.divViewFullLog') as HTMLFormElement
    fadeOut(divViewFullLog)
    const hidViewFullLog = document.getElementById('hidViewFullLog') as HTMLFormElement
    const ViewClientFullLogPartialContent = document.querySelector('.ViewClientFullLogPartialContent') as HTMLFormElement
    ViewClientFullLogPartialContent.innerHTML = ''
    fetch(
        `${hidViewFullLog.value.toString()
        }?ContactLogID=${encodeURIComponent(ContactLogID)}`,
        {
            method: 'POST'
        }
    )
        .then((response) => response.json())
        .then((result) => {
            ViewClientFullLogPartialContent.innerHTML = result
            formSubmits()
            fadeIn(divViewFullLog)
        })
}
export const ClientSearchTable = () => {
    new DataTable('#ClientSearchTable', {
        columns: [{ select: 0, sort: 'desc' }],
        labels: {
            noRows: 'No data available in table'
        },
        perPage: 10
    })
}
